exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-archive.fa-unarchive[data-v-2ee8d1eb] {\n  color: #cccccc;\n}\n", ""]);

// exports
